import React from "react";
import GetSvgIcon from "../../../images/svglist";
import ProgressBarGraph from "./ProgressBarGraph";
const CreditOverviewWidget = (props) => {

    return (
        <div className="col">
            <div className="card mb-4 shadow">
                <div className="card-header h6">
                    <span className="float-start">Credit Overview</span>
                    {/* <span className="float-end">{GetSvgIcon('FullscreenWindow')}</span> */}
                </div>
                <div className="card-body ht-48">
                    {
                        !!props?.data && props?.data.length > 0 &&
                        props?.data.map((item, index) => (
                            <ProgressBarGraph data={item} key={index} />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default CreditOverviewWidget;